module.exports = __webpack_public_path__ + "img/animationbg.ffd6146b.png";